
import { Injectable, Optional } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { JZAuthModuleConfig } from './jz-auth-module-config.service';
import { JZUser } from './jz-user';

@Injectable({
  providedIn: 'root'
})
export class JZAuthService {
  private _config = new JZAuthModuleConfig();
  private _user = new JZUser();
  public oauthService: OAuthService;

  get enable(): boolean {
    return this._config.enable;
  }

  get authConfig(): AuthConfig {
    return this._config.authConfig;
  }

  constructor(oauthService: OAuthService, @Optional() config?: JZAuthModuleConfig) {
    if (config) { this._config = config; }
    this.oauthService = oauthService;
  }

  startup() {
    if (this.enable) {
      this.oauthService.configure(this.authConfig);
      this.oauthService.loadDiscoveryDocument();
    }
  }

  get currentUser(): JZUser{
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      return null;
    }
    return {
      id: claims['sub'],
      userName: claims['name'],
      name: claims['given_name'],
      email: claims['email'],
      phoneNumber: claims['phone_number'],
    };
  }
}
